var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editType === "add" ? "新增" : "编辑",
            visible: _vm.visible,
            "close-on-click-modal": false,
            "append-to-body": "",
            width: `${900}px`,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.blackDeviceIpDailogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                "label-position": "right",
                model: _vm.formChild,
                rules: _vm.formRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标题", prop: "title" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "520px" },
                    attrs: { placeholder: "请输入标题" },
                    model: {
                      value: _vm.formChild.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.formChild, "title", $$v)
                      },
                      expression: "formChild.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上传文件", prop: "file" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "auto-upload": false,
                        "on-change": _vm.handleFileChange,
                        "on-remove": _vm.handleFileRemove,
                        "before-upload": _vm.beforeUpload,
                        "file-list": _vm.fileList,
                        limit: 1,
                        multiple: false,
                        accept: _vm.acceptTypes,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [
                          _c("p", [_vm._v("说明:")]),
                          _c("p", [_vm._v("1、上传格式为 .zip；")]),
                          _c("p", [
                            _vm._v(
                              "2、压缩包解压后为2文本文件，分别为 ID黑名单、IP黑名单； "
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formChild.file
                ? _c("el-form-item", { attrs: { label: "文件信息" } }, [
                    _c(
                      "div",
                      { staticClass: "file-info" },
                      [
                        _c("i", { staticClass: "el-icon-document" }),
                        _c("span", { staticClass: "file-name" }, [
                          _vm._v(_vm._s(_vm.formChild.file.name)),
                        ]),
                        _c("span", { staticClass: "file-size" }, [
                          _vm._v(
                            _vm._s(_vm.formatFileSize(_vm.formChild.file.size))
                          ),
                        ]),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { type: "text", size: "mini" },
                            on: { click: _vm.removeFile },
                          },
                          [_vm._v("\n            删除文件\n          ")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                    loading: _vm.submitting,
                  },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("\n        提交\n      ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "info",
                    icon: "el-icon-circle-close",
                  },
                  on: { click: _vm.blackDeviceIpDailogClose },
                },
                [_vm._v("\n        取消\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }